<template>
    <div class="career-graduates">
        <div class="container">
            <z-caption class="career-graduates__title" tag="h2" size="lt" v-if="detail.historyTitle?.value">{{ detail.historyTitle?.value }}</z-caption>
            <div class="career-graduates__wrapper">
                <div class="career-graduates__slider swiper-container swiper js-career-graduates-slider">
                    <div class="swiper-wrapper">
                        <div
                            v-for="(loopSlide, index) in detail.history"
                            :key="index"
                            class="career-graduates__slide swiper-slide u-flex u-gap--xl"
                            :class="[{ 'is-active': index === numericSlideIndex }]"
                        >
                            <div class="career-graduates__content">
                                <z-blockquote class="career-graduates__blockquote" :author="{name: loopSlide.name}">
                                    <slot>
                                        <p v-html="loopSlide.previewText"></p>
                                    </slot>
                                </z-blockquote>
                                <div class="career-graduates__card">
                                    <div class="career-graduates__card--text" v-html="loopSlide.previewText"></div>
                                    <div class="career-graduates__card--bottom u-flex u-align-center u-gap--2xs">
                                        <img class="career-graduates__card--img" :src="loopSlide.previewPicture?.link" alt="Image">
                                        <div class="career-graduates__card--author u-semi-bold">{{ loopSlide.name }}</div>
                                    </div>
                                </div>
                            </div>
                            <img class="career-graduates__slide-media" :src="loopSlide.previewPicture?.link" alt="Image">
                            <div class="career-graduates__dzen">
                                <a
                                    :href="detail.history?.[numericSlideIndex]?.link?.value || '#'"
                                    target="_blank"
                                    class="career-graduates__dzen--body u-gap--xs"
                                >
                                    <z-icon width="64" height="64" class="career-graduates__dzen--icon" name="social/yandex_zen"/>
                                    <span class="career-graduates__dzen--text">Еще больше историй<br> на Дзене</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="career-graduates__slider-controls">
                        <div class="career-graduates__slider-count">
                            <span class="career-graduates__slider-count-active">{{ formattedSlideIndex }}</span>
                            <span class="career-graduates__slider-count-all">/{{ countSlideLength }}</span>
                        </div>
                        <div class="career-graduates__slider-buttons">
                            <button
                                type="button"
                                class="career-graduates__slider-prev"
                                @click="onPrevClick"
                            >
                                <z-icon name="arrows/caret-light" width="24" height="24"/>
                            </button>
                            <button
                                type="button"
                                class="career-graduates__slider-next"
                                @click="onNextClick"
                            >
                                <z-icon name="arrows/caret-light" width="24" height="24"/>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import Swiper from 'swiper'

const props = defineProps({
    detail: {
        type: Object
    },
})
const numericSlideIndex = ref(0)
let careerGraduatesSlider;
const careerGraduatesSwiper = ref();

const onPrevClick = () => {
    if (careerGraduatesSwiper.value) {
        careerGraduatesSwiper.value.slidePrev();
    }
};

const onNextClick = () => {
    if (careerGraduatesSwiper.value) {
        careerGraduatesSwiper.value.slideNext();
    }
};

const getSpaceBetween = () => {
    return window.innerWidth < 1024 ? 25 : 100;
};

const getSlidesPerView = () => {
    return window.innerWidth < 1024 ? 1.2 : 1;
};

onMounted(() => {
    careerGraduatesSlider = document.querySelector('.js-career-graduates-slider')
    careerGraduatesSwiper.value = new Swiper(careerGraduatesSlider, {
        slidesPerView: getSlidesPerView(),
        spaceBetween: getSpaceBetween(),
        speed: 400,
        grabCursor: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: false,
        on: {
            init: function () {
                numericSlideIndex.value = this.activeIndex
            },
            slideChange: function () {
                numericSlideIndex.value = this.activeIndex
            }
        }
    })

})

window.addEventListener('resize', () => {
    if (careerGraduatesSwiper.value) {
        careerGraduatesSwiper.value.params.spaceBetween = getSpaceBetween();
        careerGraduatesSwiper.value.params.slidesPerView = getSlidesPerView();
        careerGraduatesSwiper.value.update();
    }
});

const formattedSlideIndex = computed(() =>
    numericSlideIndex.value + 1 < 10
        ? `0${numericSlideIndex.value + 1}`
        : numericSlideIndex.value + 1
);

const countSlideLength = computed(() =>
    props.detail.history.length < 10
        ? `0${props.detail.history.length}`
        : props.detail.history.length
);

</script>

<style lang="scss">
.career-graduates {
    position: relative;
    background-image: url("/media/img/career/youth-programs/bg-graduates.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    padding-top: var(--spacer-2xl);

    @include breakpoint(v-tablet) {
        padding-bottom: var(--spacer-m);
        background-image: url("/media/img/career/youth-programs/bg-graduates-mobile.png");
    }

    &__wrapper {
        position: relative;
    }

    &__content,
    &__slide-media {
        width: 50%;
        height: 100%;
    }

    &__slide {
        border-bottom: 2px solid white;
        padding-bottom: var(--spacer-s);
    }

    &__slide-media {
        margin-bottom: -80px;


        border-radius: 10px;
        clip-path: polygon(
                0 0,
                65% 0,
                100% 35%,
                100% 100%,
                35% 100%,
                0 65%
        );

        @include breakpoint(v-tablet) {
            display: none;
        }
    }

    &__content {
        @include breakpoint(v-tablet) {
            width: 100%;
        }
    }


    &__title,
    .z-blockquote__name,
    .z-blockquote__description {
        color: var(--color-white);
    }

    &__slider {
        & .swiper-wrapper {
            height: auto;
        }

        &-controls {
            display: flex;
            width: 50%;
            align-items: center;
            justify-content: space-between;
            @include gap-level(XS);
            padding-top: var(--spacer-2xs);
            padding-bottom: var(--spacer-2xs);
            padding-left: var(--spacer-xl);

            @include breakpoint(v-tablet) {
                width: 100%;
            }
        }

        &-prev, &-next {
            padding: var(--spacer-xs);
            display: flex;
            border-radius: 72px;
            border: unset;
            outline: none;
            background: rgba(255, 255, 255, 0.40);
            box-shadow: 4.8px -4.8px 4.8px 0px rgba(194, 194, 194, 0.10) inset, -4.8px 4.8px 4.8px 0px rgba(255, 255, 255, 0.10) inset;
            backdrop-filter: blur(4.800000190734863px);

            path {
                fill: var(--color-white);
            }
        }

        &-prev {
            transform: rotate(-90deg);
        }

        &-next {
            transform: rotate(90deg);
        }

        &-buttons {
            display: flex;
            align-items: center;
            @include gap-level(S);
        }

        &-count {
            &-active {
                color: rgba(255, 255, 255, 0.80);
                font-size: 28px;
                line-height: 160%;
                letter-spacing: 0.28px;
            }

            &-all {
                color: rgba(255, 255, 255, 0.80);
                @include typo-level(M);
                line-height: 160%;
                letter-spacing: 0.2px;
            }
        }
    }

    &__slide {
        @include breakpoint(v-tablet) {
            flex-direction: column;
            height: auto;
            margin-bottom: 30px;
        }
    }

    &__blockquote {
        @include breakpoint(v-tablet) {
            display: none;
        }

        .z-blockquote__name {
            @include typo-level(XL);
            padding-right: var(--spacer-l);
        }

        .z-blockquote__text {
            @include typo-level(L);
        }

        .z-blockquote__author {
            max-width: 667px;
        }
    }

    &__card {
        flex-direction: column;
        gap: 10px;
        display: none;
        border-radius: 11px;
        border: 1px solid rgba(255, 255, 255, 0.20);
        background: rgba(255, 255, 255, 0.60);
        padding: var(--spacer-m) var(--spacer-xs);
        height: 100%;
        justify-content: space-between;

        @include breakpoint(v-tablet) {
            display: flex;
        }

        &--img {
            width: 36%;
            border-radius: 10px;
            clip-path: polygon(
                    0 0,
                    65% 0,
                    100% 35%,
                    100% 100%,
                    35% 100%,
                    0 65%
            );
        }
    }

    &__dzen {
        max-width: 423px;
        padding-right: 16px;
        padding-top: 5px;
        margin-right: auto;
        position: absolute;
        right: 30px;
        bottom: -30px;
        z-index: 1;

        @include breakpoint(v-tablet) {
            position: relative;
            right: 0;
            bottom: 0;
            max-width: 300px;
        }

        &--icon {
            path {
                &:first-child {
                    fill: #282C33;
                }

                &:nth-child(2) {
                    fill: transparent;
                }
            }

            &:hover {
                path {
                    &:first-child {
                        opacity: 0.5;
                    }

                    &:nth-child(2) {
                        fill: transparent;
                    }
                }
            }

            &:active {
                path {
                    &:first-child {
                        opacity: 0.5;
                    }

                    &:nth-child(2) {
                        fill: transparent;
                    }
                }
            }
        }

        &--body {
            display: flex;
            align-items: center;
            border-radius: 30px;
            background: var(--color-white);
            padding: var(--spacer-s);
            position: relative;
            text-decoration: none;

            &::before {
                content: '';
                display: block;
                width: 32px;
                height: 45px;
                background-image: url("/media/img/dzen-tail.svg");
                background-size: contain;
                background-repeat: no-repeat;
                position: absolute;
                top: 0;
                right: -13px;
            }
        }

        &--text {
            @include typo-level(L);
            color: #292E35;
        }
    }
}
</style>
